<template>
  <div>
    <slot />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component({ name: 'NoneTransition' })
export default class NoneTransition extends Vue {}
</script>

<style lang="less" scoped></style>
